import styled from 'styled-components'

export const Details = styled.ul`
  margin: 20px 0;
  padding: 0;
  list-style: none;
  font-size: 11px;

  li {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  strong {
    text-transform: uppercase;
  }
`
